import React from "react";
import { useMutation } from "@apollo/client";
import { Upload } from "@/components/forms/Upload";
import { CREATE_WARDROBE_ITEM_MUTATION } from "@/graphql/mutations/onboarding";

type Props = {
  onSubmit: (values: any) => Promise<void>;
  onBack?: () => void;
  saving: boolean;
};

const StyleStep: React.FC<Props> = ({ onSubmit, onBack, saving }) => {
  const [createWardrobeItem, { loading: creating, error }] = useMutation(
    CREATE_WARDROBE_ITEM_MUTATION
  );

  const handleUpload = async (signedIds: string[]) => {
    try {
      await Promise.all(
        signedIds.map((id) => createWardrobeItem({ variables: { image: id } }))
      );
    } catch (e) {
      console.error("Error creating wardrobe items:", e);
    }
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit({});
  };

  return (
    <div className="space-y-12">
      <div className="text-center">
        <h2 className="text-xl font-light tracking-wider uppercase">
          Upload Your Wardrobe
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Start by uploading a few items from your closet. You can add more
          later.
        </p>
      </div>

      <Upload
        multiple={true}
        onUpload={handleUpload}
        label="Upload wardrobe items"
      />

      {error && (
        <div className="text-red-500 text-sm text-center">
          Could not save all items. Please try again.
        </div>
      )}

      <div className="flex items-center justify-between pt-6">
        <button
          type="button"
          onClick={onBack}
          className="uppercase tracking-wider font-semibold text-sm transition-colors hover:text-black dark:hover:text-white"
        >
          Back
        </button>
        <button
          type="button"
          onClick={submit}
          className="w-full md:w-auto uppercase tracking-wider font-semibold text-sm rounded-md border border-transparent bg-black dark:bg-white text-white dark:text-black px-8 py-3 transition-all hover:bg-gray-800 dark:hover:bg-gray-200 disabled:opacity-50"
          disabled={saving || creating}
        >
          {creating ? "Uploading..." : saving ? "Saving..." : "Finish"}
        </button>
      </div>
    </div>
  );
};

export default StyleStep;
